import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function FirstWeekSection() {
  const changes = ['Notarás una disminución inmediata en la tensión ambiental de la casa.', 'Tendrán al menos una conversación real sin que miren la pantalla.', 'Podrás pedirle que deje el teléfono sin recibir un grito o un portazo como respuesta.', 'Te sentirás más segura y en control de tus propias emociones al abordar el tema.'];
  return <section className="bg-primary py-10 md:py-24 px-4" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-12 shadow-card border border-border relative overflow-hidden" data-id="element-53">
          <div className="absolute top-0 left-0 w-full h-1.5 md:h-2 bg-coral" data-id="element-54"></div>

          <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center" data-id="element-55">
            <div className="md:w-1/3 text-center md:text-left" data-id="element-56">
              <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-3 md:mb-4" data-id="element-57">
                Qué cambia en los primeros{' '}
                <span className="text-coral italic" data-id="element-58">7 días</span>
              </h2>
              <p className="text-sm md:text-base text-text-secondary" data-id="element-59">
                Pequeños ajustes en tu comunicación crearán grandes cambios en
                su reacción.
              </p>
            </div>

            <div className="md:w-2/3" data-id="element-60">
              <ul className="space-y-4 md:space-y-5" data-id="element-61">
                {changes.map((change, index) => <li key={index} className="flex items-start gap-3 md:gap-4" data-id="element-62">
                    <CheckCircle2 className="w-5 h-5 md:w-6 md:h-6 text-success flex-shrink-0 mt-0.5" data-id="element-63" />
                    <p className="text-base md:text-lg text-text-primary font-medium" data-id="element-64">
                      {change}
                    </p>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}